'use client'

import React from 'react'

interface ImageDisplayProps {
  src: string
  alt: string
  className?: string
  children?: React.ReactNode
  style?: React.CSSProperties
}

/**
 * Card / media image: always fills the box with object-cover.
 * Anchored to horizontal center and ~25% from the top so faces/UI chrome stay in frame.
 * Parent must set an explicit height or aspect ratio — never leaves letterbox gaps.
 */
export default function ImageDisplay({ src, alt, className = '', children, style }: ImageDisplayProps) {
  return (
    <div className={`relative overflow-hidden ${className}`.trim()}>
      {children || (
        <img
          src={src}
          alt={alt}
          className="absolute inset-0 block h-full w-full max-w-none object-cover object-[center_25%]"
          style={style}
          loading="lazy"
          draggable={false}
        />
      )}
    </div>
  )
}
